import React from "react";
import Typewriter from "typewriter-effect";
import {useTranslation} from 'react-i18next';
// import videobg from "../videos/home.mp4";

const Home = ({ _classicHeader, _darkTheme, handleNavClick }) => {
    const {t} = useTranslation();
  return (
    <section id="home">
      <div className="hero-wrap">
        <div className="hero-mask opacity-8 bg-dark" />

        {/* ---------------image background------------------ */}
          <div className="hero-container" style={{zIndex: 1000}}>
              <div
                  className="hero-bg parallax"
                  style={{
                      backgroundImage: 'url("images/home-background.png")',
                      backgroundSize: 'cover'
                  }}
              ></div>
              {/* Rest of the content */}
          </div>



        {/* -------------------video background---------------------- */}

        {/* <div className="player hero-bg parallax">
          <video
            src={videobg}
            autoPlay
            muted
            loop
            style={{ width: "100%", height: "100vh", objectFit: "cover" }}
          ></video>
        </div> */}

        <div className="hero-content section d-flex min-vh-100">
          <div className="container my-auto">
            <div className="row">
              <div className="col-12 text-center">
                <p className="text-7 fw-500 text-white mb-2 mb-md-3">{t('home.welcome')}</p>
                <h1 className="text-16 fw-600 text-white mb-2 mb-md-3">
                  Desarrollo de Software a la Medida en Mexico
                </h1>
                <p className="text-8 fw-500 text-white mb-2 mb-md-3">
                  <Typewriter
                    options={{
                      strings: [
                          t('home.my_name'),
                        t('home.my_major'),
                        t('home.aux_work1'),
                        t('home.aux_work2'),
                      ],
                      autoStart: true,
                      loop: true,
                    }}
                  />
                </p>
                <p className="text-5 text-light mb-4">
                    {t('home.my_location')}
                </p>
                <a
                  href="#contact"
                  className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick("contact");
                  }}
                >
                    {t('home.contact_me')}
                </a>
              </div>
            </div>
          </div>
          <a
            href="#about"
            className="scroll-down-arrow text-white smooth-scroll"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("about");
            }}
          >
            <span className="animated">
              <i className="fa fa-chevron-down" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
